import Box from '@mui/material/Box'
import TextContainer from 'components/TextContainer'
import BorderRadius from 'figma/tokens/BorderRadius'
import ColorsDeprecated from 'figma/tokens/ColorsDeprecated'
import Spacings from 'figma/tokens/Spacings'
import TextKeys from 'libs/TextKeys'
import { CREDIT_REQUEST_WIDTH } from 'mynt-components/StrongHardCodedSizes'
import type { ReactNode } from 'react'
import type { AntiloopTextType } from 'tiger/interfaces/Antiloop'

export const SettingsContainer = ({
  children,
  title,
  bgColor,
  action,
}: {
  children: ReactNode
  title: AntiloopTextType | string
  bgColor?: string
  action?: ReactNode
}) => (
  <Box
    sx={{
      display: 'flex',
      width: '100%',
      padding: Spacings.medium,
      border: `1px solid ${ColorsDeprecated.baseStone}`,
      borderRadius: BorderRadius.soft,
      margin: Spacings.tiny,
      marginLeft: 0,
      minWidth: `${CREDIT_REQUEST_WIDTH}px`,
      flexDirection: 'column',
      gap: Spacings.medium,
      backgroundColor: bgColor,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {typeof title === 'object' ? (
        <TextContainer textKey={title} />
      ) : (
        <TextContainer text={title} textKey={TextKeys.billingSettingsRecurringFeesHeading} />
      )}
      {action}
    </Box>
    <>{children}</>
  </Box>
)
